import { VisualizationMode } from 'src/app/template/menu/menu.service';
import { Injectable } from '@angular/core';
import { AssetManager } from './asset-manager';
import { BehaviorSubject, Observable, withLatestFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AssetManagerFea {

  private dateChangedSubject = new BehaviorSubject(false);
  private isFeaResultActiveSubject = new BehaviorSubject(false);

  private _latestFeaMode : VisualizationMode;
  get latestFeaMode(): string {
    return this._latestFeaMode;
  }


  constructor(
    private assetManager: AssetManager,
  ) {
  }

  setIsFeaResultActive(isActive: boolean) {
    this.isFeaResultActiveSubject.next(isActive);
  }
  get isFeaResultActive$(): Observable<boolean> {
    return this.isFeaResultActiveSubject.asObservable();
  }

  setDateChanged(changed: boolean) {
    this.dateChangedSubject.next(changed);
  }
  get dateChangedWithResultActivation$(): Observable<[boolean, boolean]> {
    return this.dateChangedSubject.asObservable().pipe(
      withLatestFrom(this.isFeaResultActiveSubject)
    );
  }
  get dateChanged$(): Observable<boolean> {
    return this.dateChangedSubject.asObservable();
  }

  public enterFEA(assetViewMode: VisualizationMode) {
    this.feaAssetViewModeActivation(assetViewMode)
  }

  private feaAssetViewModeActivation(assetViewMode: VisualizationMode) {
    this.assetManager.asset.viewMode = assetViewMode

    switch (assetViewMode) {
      case 'FEAResults': // TODO: for now, all of them use the same component, so we activate the same variable
      case 'PlatePanels':
      case 'StiffenedPanels':
      case 'LargePanels':
        this._latestFeaMode = assetViewMode; // do not change when the mode is not related to fea
        this.setIsFeaResultActive(true);
        break;
      default:
        break;
    }
  }

  public exitFEM() {
    // deactivate all fea components
    this.setIsFeaResultActive(false);
  }
}
